<script setup>
import { ref, computed, onBeforeMount, watch, inject } from 'vue'
const $modal = inject('$modal');

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { UserApi } from '@/api/user'
import Alerts from "@/components/alerts/Alerts.vue";

const store = useStore()
const router = useRouter()

const show_pwa = ref(false)
const message = ref('')
const installEvent = ref(null)

const user = computed(() => store.getters.user)


onBeforeMount(() => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    installEvent.value = e
    show_pwa.value = true
  })
})

const installPWA = () => {
  installEvent.value.prompt()
}

const logout = () => {
  store.dispatch('logout')
    .then(() => {
      router.push('/login')
    })
}

const sendFeedBack = () => {
  UserApi.feedback({ message: message.value }).then(() => {
    $modal('hide', 'feedback')
    $modal('show', 'success_feedback')
  })
}

</script>

<template>
  <header
      class="navbar ps-4 pe-4 ">
    <router-link
        :class="`navbar-brand col-auto ${$store.getters.company.logo} ${$store.getters.sidebar_state?'collapse':''}`"
        to="/">
    </router-link>

    <template v-if="$store.getters.isLoggedIn">

      <ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">

        <li>
          <button @click="$modal('show', 'feedback')" class="btn btn-sm btn-primary btn-sm rounded-5">
            <i class="bi bi-chat-dots"></i>
            <span>Обратная связь</span>
          </button>
        </li>
        <li v-if="show_pwa">
          <a href="" v-on:click.prevent="installPWA" title="Установить приложение" class="nav-link text-white">
            <i class="bi bi-box-arrow-down"></i>
          </a>
        </li>
        <Alerts></Alerts>

        <li class="user-info">
          <router-link to="/settings/" title="Личный кабинет" class="nav-link text-white">
            <i class="bi bi-person-circle"></i>
            <span>{{ user.fullname }}</span>
          </router-link>
        </li>
        <li class="logout">

          <a href="#" @click.prevent="logout" title="Выход" class="no-wrap btn btn-outline-primary btn-sm rounded-5">
            Выход
          </a>
        </li>
      </ul>
      <button class="navbar-toggler d-md-none collapsed text-white" type="button"
              @click="$store.dispatch('toggle_sidebar')">
        <i v-if="!$store.getters.sidebar_state" class="bi bi-list"></i>
        <i v-else class="bi bi-x-lg"></i>
      </button>

    </template>

    <modal modal_id="feedback">
      <template v-slot:header>
        <h1>Обратная связь</h1>
      </template>
      <template v-slot:body>
        <form action="." @submit.prevent="sendFeedBack()">
          <div>
            <textarea required class="form-control text-black" name="" id="" cols="30" rows="30" v-model="message"
                      placeholder="Введите ваше сообщение"></textarea>
            <button style="display: none" ref="feed_form" type="submit"></button>
          </div>
        </form>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'feedback');"
                data-bs-dismiss="modal"> Отмена
        </button>
        <button type="button" class="btn btn-primary" v-on:click.prevent="$refs['feed_form'].click()">Отправить
        </button>
      </template>

    </modal>
    <modal modal_id="success_feedback">
      <template v-slot:header>
      </template>
      <template v-slot:body>
        <h3>Спасибо. Ваше обращение принято в обработку</h3>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'success_feedback');"
                data-bs-dismiss="modal"> Закрыть
        </button>
      </template>

    </modal>

  </header>
</template>

<style scoped lang="scss">
textarea {
  height: 237px;
  max-height: 90%;

  &::placeholder {
    color: #000;
  }
}


</style>

